import React, { useState } from "react";

import TextField from "@material-ui/core/TextField";
import { StyledGrid } from "components/simple";

interface Props {
  callback?: React.Dispatch<string>;
  currentValue: string;
  max?: number;
  min?: number;
}

const ScoreInput: React.FC<Props> = ({ callback, currentValue, max, min }: Props) => {
  const [value, setValue] = useState(currentValue === undefined ? "" : currentValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    let value = event.target.value;

    if (value !== "") {
      value = Math.max(0, Number(event.target.value)).toString();

      if (min && min !== null) {
        if (Number(value) < min) return;
      }

      if (max && max !== null) {
        if (Number(value) > max) return;
      }
    }

    setValue(value);

    if (callback) {
      callback(value);
    }
  };

  return (
    <StyledGrid container wrap="nowrap">
      <TextField
        helperText={
          min !== null && max !== null
            ? `${min}-${max}`
            : max !== null
            ? `<${max}`
            : min !== null
            ? `>${min}`
            : ""
        }
        onChange={handleChange}
        type="number"
        value={value}
        inputProps={{
          max,
          min,
          "data-testid": "score-input"
        }}
      />
    </StyledGrid>
  );
};

export default ScoreInput;
